import { evmConfig } from '@/service/EVM/config';

export type ConfigsProvider = typeof configsProvider;
export type ProviderConfig<P extends keyof ConfigsProvider> = ConfigsProvider[P];
export type ConfigProviderInstance = InstanceType<typeof Config>;

const configsProvider = {
    evm: evmConfig
} as const;

export class Config {
    public readonly configs: ConfigsProvider;

    constructor() {
        this.configs = configsProvider;
    }

    public getConfigsProvider<P extends keyof ConfigsProvider>(provider: P): ProviderConfig<P> {
        return this.configs[provider];
    }

    public getConfigFields<P extends keyof ConfigsProvider, K extends keyof ProviderConfig<P>>(
        provider: P = 'evm' as P,
        keys: readonly K[]
    ): Pick<ProviderConfig<P>, K> {
        const configItem = this.getConfigsProvider(provider);

        return keys.reduce((acc, key) => {
            acc[key] = configItem[key];
            return acc;
        }, {} as Pick<ProviderConfig<P>, K>);
    }
}
